import { type AnyToken, NativeTokens, SupportedTokens } from '@trinity/blockchain-common'

export const TOKEN_SYMBOLS: Record<AnyToken, string> = {
    [SupportedTokens.xUty]: 'xUTY',
    [SupportedTokens.mUty]: 'mUTY',
    [SupportedTokens.UTY]: 'UTY',
    [NativeTokens.Main]: 'AVAX',
} as const
